import { useState } from 'react'
import { useDashboard } from '../Provider'
import { useDispatch } from 'react-redux'
import { useDialogs } from '@shared/hooks/dialogs'
import { useMethods } from '@shared/hooks/methods'

import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import MUIAppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Search from './Search'

import MenuIcon from '@mui/icons-material/Menu'
import SearchIcon from '@mui/icons-material/Search'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'

import { toggleMode } from '@shared/redux/slices/mode'
import axios from '@shared/utils/axios'
import Link from '@mui/material/Link'

export default function AppBar() {
    const {
        title,
        open,
        setOpen
    } = useDashboard()
    const [anchor, setAnchor] = useState(null)
    const dispatch = useDispatch()
    const { show } = useDialogs()
    const { showMessage } = useMethods()
    const [searchOpen, setSearchOpen] = useState(false)

    const handleProfile = async () => {
        setAnchor(null)
        showMessage({
            text: 'جارٍ تحميل البيانات',
            loading: true
        })
        try {
            const profile = (await axios.get('settings/users/profile')).data
            show('user', {instance: profile})
            showMessage(null)
        } catch {
            showMessage({ text: 'حدث خطأ' })
        }
    }

    return (
        <MUIAppBar
            color='transparent'
            elevation={0}
            sx={{width: '100%'}}
            position='sticky'
        >
            <Toolbar>
                <IconButton onClick={() => setOpen(!open)} edge='start' sx={{marginInlineEnd: 2}}>
                    <MenuIcon />
                </IconButton>
                {searchOpen ? (
                    <Search onClose={() => setSearchOpen(false)} />
                ) : (
                    <Typography sx={{ flexGrow: 1 }} variant="h6">
                        {title}
                    </Typography>
                )}

                {!searchOpen &&
                    <IconButton onClick={() => setSearchOpen(true)}>
                        <SearchIcon />
                    </IconButton>
                }
                <IconButton
                    onClick={e => setAnchor(e.currentTarget)}
                    edge='end'
                ><AccountCircleIcon /></IconButton>
                <Menu
                    open={!!anchor}
                    anchorEl={anchor}
                    onClose={() => setAnchor(null)}
                >
                    <MenuItem onClick={handleProfile}>تعديل الحساب</MenuItem>
                    <MenuItem onClick={() => {
                        setAnchor(null)
                        dispatch(toggleMode())
                    }}>تحويل المظهر</MenuItem>
                    <Link
                        href='/auth/logout'
                        color='textPrimary'
                        underline='none'
                    >
                        <MenuItem>تسجيل الخروج</MenuItem>
                    </Link>
                </Menu>
            </Toolbar>
        </MUIAppBar>
    )
}